import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    class: { "create-annotations-button-container": true, active: this.isAttributeEnabled(`active`) }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `plus` }
  }));
}
